module.exports = __webpack_public_path__ + "img/extractPages.07ea5247.svg";